import { z } from 'zod';

const AuditPlanAuditItemSchema = z.object({
    assessment: z.string().min(1),
    plannedStartDate: z.union([z.string(), z.date()]).optional(),
    plannedEndDate: z.union([z.string(), z.date()]).optional(),
    unit: z.string().optional(),
    scope: z.string().optional(),
    status: z.enum(['planned', 'in-progress', 'completed', 'postponed', 'cancelled']).optional(),
});

const auditsField = z.array(
    z.union([
        z.string().min(1).transform((id) => ({ assessment: id })),
        AuditPlanAuditItemSchema,
    ])
).optional();

/** Accept a flat `assessments` id list / `approvalStatus` alias; persist `audits` + `status`. */
export function normalizeAuditPlanInput(data) {
    if (!data || typeof data !== 'object' || Array.isArray(data)) return data;
    const { assessments, approvalStatus, ...rest } = data;
    const next = { ...rest };
    if (next.status == null && approvalStatus != null) {
        next.status = approvalStatus;
    }
    if (next.audits == null && Array.isArray(assessments)) {
        next.audits = assessments.map((item) => (
            typeof item === 'string' || typeof item === 'number'
                ? { assessment: String(item) }
                : item
        ));
    }
    return next;
}

export const AuditPlanSchema = z.object({
    id: z.string().optional(),
    year: z.number().int().optional(),
    title: z.string().min(1),
    description: z.string().optional(),
    audits: auditsField,
    status: z.enum(['draft', 'approved', 'active', 'completed']).default('draft'),
    approvedBy: z.string().optional(),
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
});
export const CreateAuditPlanSchema = z.preprocess(
    normalizeAuditPlanInput,
    AuditPlanSchema.omit({ id: true, createdAt: true, updatedAt: true })
);
export const UpdateAuditPlanSchema = z.preprocess(
    normalizeAuditPlanInput,
    AuditPlanSchema.partial()
);
